import { render } from "./StandardHeaderLogoImage.vue?vue&type=template&id=727fc603"
import script from "./StandardHeaderLogoImage.vue?vue&type=script&lang=js"
export * from "./StandardHeaderLogoImage.vue?vue&type=script&lang=js"

import "./StandardHeaderLogoImage.vue?vue&type=style&index=0&id=727fc603&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__